import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';

export const Footer = () => {
  const handleSocialClick = (e, platform) => {
    e.preventDefault();
    alert(`${platform} page coming soon! Follow us for updates.`);
  };

  return (
    <footer className="bg-[#404040] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_harry-and-jacobs/artifacts/7nr8z83x_Insta%20Profile%20Pic.jpg" 
                alt="Harry & Jacobs Logo" 
                className="h-16 w-16 rounded-full"
              />
            </div>
            <h3 className="font-bold text-lg mb-2">Harry & Jacobs</h3>
            <p className="text-gray-300 text-sm mb-4">
              Your trusted estate agent in Harrow. We're here to help you every step of the way.
            </p>
            <div className="text-sm text-gray-300 mb-2">
              <strong className="text-[#FF8C42]">Global Presence:</strong>
            </div>
            <p className="text-xs text-gray-400">
              UK • Kuwait • Iraq • Saudi Arabia • UAE
            </p>
            <div className="flex space-x-3 mt-4">
              <button onClick={(e) => handleSocialClick(e, 'Facebook')} className="hover:text-[#FF8C42] transition-colors cursor-pointer">
                <Facebook className="w-5 h-5" />
              </button>
              <button onClick={(e) => handleSocialClick(e, 'Instagram')} className="hover:text-[#FF8C42] transition-colors cursor-pointer">
                <Instagram className="w-5 h-5" />
              </button>
              <button onClick={(e) => handleSocialClick(e, 'LinkedIn')} className="hover:text-[#FF8C42] transition-colors cursor-pointer">
                <Linkedin className="w-5 h-5" />
              </button>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/properties" className="text-gray-300 hover:text-[#FF8C42] transition-colors text-sm">
                  Properties for Sale
                </Link>
              </li>
              <li>
                <Link to="/properties" className="text-gray-300 hover:text-[#FF8C42] transition-colors text-sm">
                  Properties to Rent
                </Link>
              </li>
              <li>
                <Link to="/architecture" className="text-gray-300 hover:text-[#FF8C42] transition-colors text-sm">
                  Architecture Services
                </Link>
              </li>
              <li>
                <Link to="/branches" className="text-gray-300 hover:text-[#FF8C42] transition-colors text-sm">
                  Our Branches
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-[#FF8C42] transition-colors text-sm">
                  Our Services
                </Link>
              </li>
              <li>
                <Link to="/valuation" className="text-gray-300 hover:text-[#FF8C42] transition-colors text-sm">
                  Free Valuation
                </Link>
              </li>
            </ul>
          </div>

          {/* Portals */}
          <div>
            <h3 className="font-bold text-lg mb-4">Portals</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/landlord/login" className="text-gray-300 hover:text-[#FF8C42] transition-colors text-sm">
                  Landlord Portal
                </Link>
              </li>
              <li>
                <Link to="/client/login" className="text-gray-300 hover:text-[#FF8C42] transition-colors text-sm">
                  Architecture Client Portal
                </Link>
              </li>
              <li>
                <Link to="/employee/login" className="text-gray-300 hover:text-[#FF8C42] transition-colors text-sm">
                  Employee Portal
                </Link>
              </li>
              <li>
                <Link to="/admin/login" className="text-gray-300 hover:text-[#FF8C42] transition-colors text-sm">
                  Admin Portal
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-[#FF8C42] transition-colors text-sm">
                  About Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-bold text-lg mb-4">Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/properties?type=sale" className="text-gray-300 hover:text-[#FF8C42] transition-colors text-sm">
                  Property Sales
                </Link>
              </li>
              <li>
                <Link to="/properties?type=rent" className="text-gray-300 hover:text-[#FF8C42] transition-colors text-sm">
                  Property Lettings
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-[#FF8C42] transition-colors text-sm">
                  Property Management
                </Link>
              </li>
              <li>
                <Link to="/valuation" className="text-gray-300 hover:text-[#FF8C42] transition-colors text-sm">
                  Expert Valuations
                </Link>
              </li>
              <li>
                <Link to="/architecture" className="text-gray-300 hover:text-[#FF8C42] transition-colors text-sm">
                  Architectural Design
                </Link>
              </li>
              <li>
                <Link to="/architecture/quote" className="text-gray-300 hover:text-[#FF8C42] transition-colors text-sm">
                  Planning Permission
                </Link>
              </li>
            </ul>
          </div>

          {/* Coming Soon Branches */}
          <div>
            <h3 className="font-bold text-lg mb-4">Coming Soon</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-gray-300 text-sm">
                <span className="text-xl">🇦🇪</span>
                <span>Dubai</span>
              </li>
              <li className="flex items-center gap-2 text-gray-300 text-sm">
                <span className="text-xl">🇮🇶</span>
                <span>Baghdad</span>
              </li>
              <li className="flex items-center gap-2 text-gray-300 text-sm">
                <span className="text-xl">🇸🇦</span>
                <span>Riyadh</span>
              </li>
              <li className="flex items-center gap-2 text-gray-300 text-sm">
                <span className="text-xl">🇰🇼</span>
                <span>Kuwait City</span>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-bold text-lg mb-4">Contact Us</h3>
            <div className="space-y-3">
              <a 
                href="https://www.google.com/maps/search/?api=1&query=25+Masons+Avenue+Harrow+HA3+5AH+UK" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-start space-x-3 group"
              >
                <MapPin className="w-5 h-5 text-[#FF8C42] flex-shrink-0 mt-0.5" />
                <span className="text-gray-300 group-hover:text-[#FF8C42] transition-colors text-sm">
                  25 Masons Avenue<br />
                  Harrow HA3 5AH, UK
                </span>
              </a>
              <a href="tel:+442081898889" className="flex items-center space-x-3 group">
                <Phone className="w-5 h-5 text-[#FF8C42]" />
                <span className="text-gray-300 group-hover:text-[#FF8C42] transition-colors text-sm">
                  020 8189 8889
                </span>
              </a>
              <a href="mailto:info@harryandjacobs.com" className="flex items-center space-x-3 group">
                <Mail className="w-5 h-5 text-[#FF8C42]" />
                <span className="text-gray-300 group-hover:text-[#FF8C42] transition-colors text-sm">
                  info@harryandjacobs.com
                </span>
              </a>
            </div>
            <div className="mt-4 text-sm text-gray-400">
              <p>Mon-Fri: 9:00 AM - 6:00 PM</p>
              <p>Sat: 10:00 AM - 4:00 PM</p>
              <p>Sun: Closed</p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-600 mt-8 pt-8 text-center text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} Harry & Jacobs Estate Agency. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
